var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M18.0904 0L18.2857 3.17965C11.8907 7.58071 9.55934 12.1724 6.68406 18C4.67866 15.5895 1.815 14.1052 0 12.8982C0.565114 12.2469 1.17671 11.5331 1.77529 10.8952C3.5904 12.1614 5.23117 13.4647 6.57752 15.1617C8.40609 10.1432 13.5579 3.2616 18.0904 0Z","fill":"#00A179"}));
}

Tick.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
